// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message[data-v-d759b704] {\n  color: #d3d3d3;\n  box-shadow: none;\n}\n.message--suggestion[data-v-d759b704] {\n  color: #d3d3d3 !important;\n}", ""]);
// Exports
module.exports = exports;
